import { getSharedWithUsers, getEntity, shareUnshareUsers } from '../api'

export const populateSharedUsers = ({ state, commit }, {entityType, entityUuid}) => {
  console.log('in populateSharedUsers, params: ', entityType, entityUuid)
  return getSharedWithUsers(entityType, entityUuid).then((response) => {
    commit('LOAD_SHARED_USERS', response)
    console.log('populateSharedUsers action response: ', response)
    return response
  })
}

export const updateUsersPermissions = ({ state, commit }, {sharedUsers, entityType, entityUuid}) => {
  console.log('in updateUsersPermissions, params: ', sharedUsers, entityType, entityUuid)
  return shareUnshareUsers(sharedUsers, entityType, entityUuid).then((response) => {
    console.log('populateSharedUsers action response: ', response)
    return response
  })
}

export const populateSharedEntity = ({ state, commit }, {entityType, entityUuid}) => {
  console.log('in populateSharedEntity, params: ', entityType, entityUuid)
  return getEntity(entityType, entityUuid).then((response) => {
    commit('LOAD_SHARED_ENTITY', response)
    console.log('populateSharedEntity action response: ', response)
    return response
  })
}



// WEBPACK FOOTER //
// ./src/app/sharing/vuex/actions.js